export default class Flow {
    constructor(dto) {
        this.id = -1;
        this.name = '';
        this.contentTypeIDs = [];
        this.defFieldCode = '';
        this.activeNotif = false;
        this.notifyByEmail = false;

        if (dto) {
            Object.keys(dto).forEach((key) => {
                this[key] = dto[key];
            });
        }
    }

    toDto() {
        return {
            Id: this.id,
            Name: this.name,
            ContentTypeIDs: this.contentTypeIDs,
            DefFieldCode: this.defFieldCode,
            ActiveNotif: this.activeNotif,
            NotifyByEmail: this.notifyByEmail,
        };
    }
}
